import { Box, TextField, Tooltip, IconButton, LinearProgress, Button, Typography } from '@mui/material'
import { useInsumo } from '../../../shared/context/insumoContext'
import { useState, useEffect } from 'react'
import { useUtiles } from '../../../shared/context/utilesContext'
import CreateTypeInsumoComponent from './CreateTypeInsumoComponent'
import { Refresh as RefreshIcon, Add as AddIcon } from '@mui/icons-material'
import InventoryIcon from '@mui/icons-material/Inventory';
export default function SelectTypeInsumoComponent() {
    const { getTypeInsumos, loadingTypeInsumos, typeInsumos, setSelectTypeInsumo } = useInsumo()
    const { toogleOpenSilder, saveCurrentComponent, openSilderWith } = useUtiles()

    const handleSearch = (e) => {
        getTypeInsumos({name: e.target.value})
    }

    useEffect(() => {
        getTypeInsumos()
    }, [])

    const handleCreateTypeInsumo = () => {
        saveCurrentComponent()
        openSilderWith(<CreateTypeInsumoComponent />, 500, 'Crear tipo de insumo')
    }

    const handleSelectTypeInsumo = (type) => {
        setSelectTypeInsumo(type)
        toogleOpenSilder(null, 0, '')
    }

    return (
        <Box sx={{ padding: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <TextField fullWidth placeholder="Escribe para buscar" size="small" onChange={handleSearch} />
            <Tooltip title="Refrescar">
                <IconButton size="small" onClick={() => getTypeInsumos()}>
                    <RefreshIcon  />
                </IconButton>
            </Tooltip>
        </Box>
        <Button 
            size="small" 
            variant="contained" 
            color="primary" 
            sx={{ mt: 1 }} 
            startIcon={<AddIcon />}
            onClick={handleCreateTypeInsumo}
        >
            Crear tipo de insumo
        </Button>
        {
            loadingTypeInsumos && <LinearProgress sx={{ mt: 2 }} />
        }


        <Box sx={{ mt: 2,  maxHeight: '600px', overflow: 'auto', px: 1 }}>
            {typeInsumos.length > 0 ? (
                typeInsumos.map((type) => (
                    <Box 
                        key={type.id}
                        onClick={() => handleSelectTypeInsumo(type)}
                        sx={(theme) => ({
                            p: 1.5,
                            mb: 1,
                            borderRadius: "8px",
                            backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)',
                            transition: 'all 0.2s',
                            cursor: 'pointer',
                            '&:hover': {
                                backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                                transform: 'translateY(-2px)',
                                boxShadow: '0 4px 8px rgba(0,0,0,0.05)'
                            },
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                        })}
                    >
                        <Box sx={{ 
                            mr: 2,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            backgroundColor: (theme) => theme.palette.primary.main,
                            color: '#fff'
                        }}>
                            <IconButton size="small" sx={{ color: "#fff", p: 0.5 }}>
                                <InventoryIcon />
                            </IconButton>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography variant="body2" sx={(theme) => ({ 
                                color: theme.palette.text.primary,
                                fontWeight: 500
                            })}>
                                {type.name}
                            </Typography>
                        </Box>
                    </Box>
                ))
            ) : (
                <Box sx={{ 
                    p: 2, 
                    textAlign: 'center', 
                    color: 'text.secondary',
                    backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)',
                    borderRadius: '8px'
                }}>
                    No hay tipos de insumos disponibles
                </Box>
            )}
        </Box>
        </Box>
    )
}

